module.exports = __webpack_public_path__ + "h5/img/xinlai@2x.f07bffdd.png";